import { render, staticRenderFns } from "./googleCheck.vue?vue&type=template&id=b480fd26&scoped=true&"
import script from "./googleCheck.vue?vue&type=script&lang=js&"
export * from "./googleCheck.vue?vue&type=script&lang=js&"
import style0 from "./googleCheck.vue?vue&type=style&index=0&id=b480fd26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b480fd26",
  null
  
)

export default component.exports